<template>
  <div class="user-agreement">
    <pcHeader></pcHeader>
    <div class="content-box">
      <!-- <div class="cont-name"></div> -->
      <div class="cursor">
        <span @click="goNext('/')">首页</span>
        > {{name}}
      </div>
      <div class="user-info-box">
        <a-layout>
          <a-layout-sider>
            <!-- icon-Outpatient-Department -->
            <a-menu v-model="current" theme="dark" mode="inline">
              <a-menu-item v-for="item in menus" :key="item.url" @click="goNext(item.url)">
                <icon-font :v-show="false" :type="item.iconName" />
                <span>{{ item.name }}</span>
              </a-menu-item>
            </a-menu>
          </a-layout-sider>
          <a-layout>
            <a-layout-content>
              <router-view />
            </a-layout-content>
          </a-layout>
        </a-layout>
      </div>
    </div>
  </div>
</template>
<script>
import pcHeader from "@/components/Header";

export default {
  components: {
    pcHeader,
  },
  data() {
    return {
      current: ["/user-agreement/agreement"],
      menus: [
        {
          url: "/user-agreement/agreement",
          name: "用户协议",
        },
        {
          url: "/user-agreement/privacy",
          name: "隐私协议",
        },
        {
          url: "/user-agreement/relation",
          name: "联系我们",
        },
        {
          url: "/user-agreement/help",
          name: "帮助中心",
        },
      ],
    };
  },
  created() {
    this.menus.forEach((item) => {
      if (this.$route.path.indexOf(item.url) >= 0) {
        this.current[0] = item.url;
        this.name = this.$route.meta.name;
      }
    });
  },
  watch: {
    $route() {
      this.menus.forEach((item) => {
        if (this.$route.path.indexOf(item.url) >= 0) {
          this.current[0] = item.url;
          this.name = this.$route.meta.name;
        }
      });
    },
  },
  methods: {
    //前往下个页面
    goNext(val) {
      this.$router.replace({
        path: val,
        query: {},
      });
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.user-agreement {
  .content-box {
    width: 1200px;
    margin: auto;
    .cont-name {
      font-size: 26px;
      font-weight: 400;
      color: #3385ed;
      line-height: 42px;
      border-bottom: 2px solid #3385ed;
      padding-bottom: 15px;
    }
    .user-info-box {
      margin-top: 23px;
      .ant-layout-sider {
        background: #fff;
      }
      .ant-menu-dark {
        // width: 200px;
        background: rgba(51, 133, 237, 0.08);
        height: 610px;

        .ant-menu-item {
          font-size: 16px;
          font-weight: 400;
          color: #999999;
          .anticon {
            font-size: 20px;
          }
        }
      }
      .ant-layout-content {
        padding-left: 40px;
        background: #fff;
      }
    }
  }
}
.cursor {
  cursor: default;
}
</style>
